export default __webpack_public_path__ + "static/media/cert-general-staff-HKIRC.0390698e.jpg";